export default __webpack_public_path__ + "static/gardeners-7eb7ac5fc7e2d9631ae88566d77adbfc.webp";